var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssetKuroProductMediaDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 15,
    viewBox: "0 0 12.5 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(-326 -255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M13.875,2.5H11.938A3.131,3.131,0,0,0,8.875,0H7.625A3.131,3.131,0,0,0,4.563,2.5H2.625a.625.625,0,0,0,0,1.25H3.25v8.125A3.129,3.129,0,0,0,6.375,15h3.75a3.129,3.129,0,0,0,3.125-3.125V3.75h.625a.625.625,0,0,0,0-1.25ZM7.625,1.25h1.25A1.879,1.879,0,0,1,10.643,2.5H5.857A1.879,1.879,0,0,1,7.625,1.25ZM12,11.875a1.875,1.875,0,0,1-1.875,1.875H6.375A1.875,1.875,0,0,1,4.5,11.875V3.75H12Z",
    transform: "translate(324 255)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_692",
    "data-name": "Path 692",
    d: "M9.687,15.5a.687.687,0,0,0,.687-.687V10.687a.687.687,0,0,0-1.374,0v4.121A.687.687,0,0,0,9.687,15.5Z",
    transform: "translate(321.083 250.627)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_693",
    "data-name": "Path 693",
    d: "M13.687,15.5a.687.687,0,0,0,.687-.687V10.687a.687.687,0,0,0-1.374,0v4.121A.687.687,0,0,0,13.687,15.5Z",
    transform: "translate(320.043 250.627)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetKuroProductMediaDeleteIcon);
export default __webpack_public_path__ + "static/media/Asset-KuroProductMediaDeleteIcon.33aff54c0a14827b57f60dea5b55c955.svg";
export { ForwardRef as ReactComponent };